import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";
import { stopTimer} from "../api";

class Contact extends Component {

    render (){

        stopTimer(); 
        return (
            <div>
                <Breadcrumb title={'Contact Us'}/>
                
                
                {/*Forgot Password section*/}
                <section className=" contact-page section-b-space">
                    <div className="container">
                        <div className="row section-b-space">
                            <div className="col-4">
                                <div className="contact-right">
                                    <ul>
                                        <li>
                                            <div className="contact-icon">
                                                <img src={`${process.env.PUBLIC_URL}/assets/images/icon/phone.png`} alt="Generic placeholder" />
                                                    <h6>Contact Us</h6>
                                            </div>
                                            <div className="media-body">
                                                <p>214-799-0998</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="contact-icon">
                                                <img src={`${process.env.PUBLIC_URL}/assets/images/icon/email.png`} alt="Generic placeholder" />
                                                    <h6>Email</h6>
                                            </div>
                                            <div className="media-body">
                                                <p><a href = "mailto:info@americanspeech.org">info@americanspeech.org</a></p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="contact-icon">
                                                <i className="fa fa-facebook-official" aria-hidden="true"></i>
                                                <h6>Social Media</h6>
                                            </div>
                                            <div className="media-body">
                                                <p><a href = "https://www.facebook.com/AmericanSpeechDebate">Facebook</a></p>
                                                <p><a href = "https://www.instagram.com/american.speech.and.debate/">Instagram</a></p>
                                                <p><a href = "https://www.youtube.com/channel/UC7nzw5cksvsNxheqspgXTrQ">YouTube</a></p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-8">
                                <div className="container">                        
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <h3>Privacy Policy</h3>
                                            <p>www.impacttournaments.com and Lasting Impact collect visitor data and analyze traffic on our site. This information helps us understand customer interests and helps us improve our website. When you visit our site, the pages that you look at, and a short text file called a cookie, are downloaded to your computer. A cookie is used to store small amounts of information. This information is collected for traffic analysis only. The cookie does not contain personal details. Depending on the browser that you use, you can set your preferences to block/ refuse cookies, and/ or notify you before they are placed. Lasting Impact / impacttournaments.com do not sell, give, or trade the statistics they store to any 3rd parties for data-mining or marketing purposes. </p>
                                            <br />
                                            <h3>Terms and Conditions</h3>
                                            <p>Please read thse Terms and Conditions("Terms", "Terms and Conditions") carefully before using the https://www.impacttournaments.com website (the "service") operated by Lasting Impact ("us", "we", or "our").</p>
                                            <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these terms.  These terms apply to all visitors, users, and others who access or use the Service.</p>
                                            <p>By accessing or using the Sevice you agree to be bound by these Terms.  If you disagree with any part of the terms then you may not access the Service.</p>
                                            <p>We may terminate or suspend access to our Servie immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
                                            <p>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownwership provisions, wrranty disclaimes, indemnity and limitations of liability.</p>
                                        </div>
                                    </div>
                                </div>                            
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default Contact